<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

import CardComponent from '@/components/ui/CardComponent.vue';
import AppLogoComponent from '@/components/ui/AppLogoComponent.vue';

const { t } = useI18n()
const router = useRouter()

const redirectToLogin = async () => {
	await router.push('/login')
}
</script>

<template>
	<v-container fluid class="h-screen w-full d-flex justify-center align-center">
		<CardComponent>
			<template #title>
				<div class="d-flex align-center justify-center my-4">
          <AppLogoComponent />
				</div>
			</template>
			<template #item>
				<v-row>
					<v-col cols="12">
						<h3>{{ t('views.resetPasswordConfirmed.title') }}</h3>
					</v-col>
					<v-col cols="12">
						<p class="text-subtitle-2">{{ t('views.resetPasswordConfirmed.description') }}</p>
					</v-col>
					<v-col cols="12">
						<v-btn block @click="redirectToLogin">
							{{ t('views.resetPasswordConfirmed.buttons.redirectToLogin') }}
							<template #append>
								<v-icon icon="PhSignIn" />
							</template>
						</v-btn>
					</v-col>
				</v-row>
			</template>
		</CardComponent>
	</v-container>
</template>
